import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';

export const NOT_AUTHORIZED_PATH = '/not-authorized';

/**
 * True for the API's "authenticated but holds no CMT role" response (HTTP 403, body code NO_ROLES).
 * Accepts a raw HttpErrorResponse (what an interceptor sees) or an ApolloError wrapping one in
 * `networkError` (what callers of Apollo see), so guards and services can share the same check.
 */
export function isNoRolesError(err: unknown): boolean {
  const candidate = (err as { networkError?: unknown } | null)?.networkError ?? err;
  return (
    candidate instanceof HttpErrorResponse &&
    candidate.status === 403 &&
    candidate.error?.code === 'NO_ROLES'
  );
}

/**
 * Sends the user to the Not Authorized page whenever the API answers NO_ROLES.
 *
 * Apollo issues its requests through Angular's HttpClient, so this sees every GraphQL call. It covers
 * the login-time currentUser query as well as a role being removed while the user is already inside
 * the app. The error is re-thrown so callers still see the failure and nothing renders stale data.
 */
@Injectable()
export class NoRolesInterceptor implements HttpInterceptor {

  private readonly router = inject(Router);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: unknown) => {

    console.log('API error', err);

        // The URL check stops the Not Authorized page's own calls from redirecting to itself.
        if (isNoRolesError(err) && !this.router.url.startsWith(NOT_AUTHORIZED_PATH)) {
          void this.router.navigate([NOT_AUTHORIZED_PATH], { replaceUrl: true });
        }
        return throwError(() => err);
      })
    );
  }
}
